import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MobileBanner from './MobileBanner';
import Banner from './Banner';
import SideWidget from './SideWidget';
import { logEvent } from '../../../../new-lib/analytics';

export interface ExpoBannerContainerProps {
  handleClose?: () => void;
  handleShow?: () => void;
}

const ExpoBannerContainer = () => {
  const [shouldShowBanner, setShouldShowBanner] = useState(false);
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const handleClose = () => {
    document.querySelector('#expo-content-modal')?.classList.add('disappear');
    document.querySelector('#expo-banner')?.classList.add('remove-overlay');
    logEvent.click('Nawy_expo_banner_close', 'Nawy_expo_banner', 'other');

    setTimeout(() => {
      localStorage.setItem('showExpoBanner', 'false');
      setShouldShowBanner(false);
    }, 200);
  };
  const handleShow = () => {
    logEvent.click('Nawy_expo_sticky_click', 'Nawy_expo_banner', 'other');
    setShouldShowBanner(true);
    localStorage.setItem('showExpoBanner', 'true');
  };

  useEffect(() => {
    const showExpoBanner = localStorage.getItem('showExpoBanner');
    setShouldShowBanner(showExpoBanner === null || showExpoBanner === 'true');
  }, []);

  if (!shouldShowBanner) {
    return <SideWidget handleShow={handleShow} />;
  }

  return isMobile ? (
    <MobileBanner handleClose={handleClose} />
  ) : (
    <Banner handleClose={handleClose} />
  );
};

export default ExpoBannerContainer;
